import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@flabs/shared';
import { StaticPagesComponent } from './static-pages.component';
import { StaticPagesService } from './static-pages.service';

const routes: Routes = [{ path: ':page', component: StaticPagesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes), SharedModule],
  declarations: [],
  exports: [StaticPagesComponent],
  providers: [StaticPagesService],
})
export class StaticPagesModule {}
